





























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'search-result-suggested-products',
})

export default class extends Vue {
  @Prop() private resultData: Array<object>;
  @Prop() private searchQuery: string;

  private limit: number = 3;

  private getUrl(product: object): string {
    if (this.searchQuery.length > 5 && /^\d+$/.test(this.searchQuery)) {
      return product['url'];
    }

    return `${product['url']}?query=${this.searchQuery}`;
  }

  private imageSrc(product): string {
    const image = product.hasOwnProperty('image');

    if(image) {
      return `https://cdn.mamaloes.nl/catalog/product/60/60${product.image}`;
    }
    return '/area/web/default/assets/images/logo.svg';
  }
}
